/**
 * Shared priority styling for list surfaces (table pill, side panel, filter dropdown).
 *
 * Labels come from `PRIORITY_LABELS` in `@/types/lists`.
 */
import type { ListPriority } from '@/types/lists';

export const LIST_PRIORITY_ORDER: ListPriority[] = ['high', 'medium', 'low'];

/** Pill classes (background + text + ring) for a filled priority badge. */
export const LIST_PRIORITY_BADGE: Record<ListPriority, string> = {
  high: 'bg-red-500/20 text-red-400 ring-red-500/30',
  medium: 'bg-amber-500/20 text-amber-400 ring-amber-500/30',
  low: 'bg-slate-500/20 text-slate-400 ring-slate-500/30',
};

/** Text colour only, for icons rendered outside a badge. */
export const LIST_PRIORITY_TEXT: Record<ListPriority, string> = {
  high: 'text-red-400',
  medium: 'text-amber-400',
  low: 'text-slate-400',
};
